var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveUserIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D92D20",
    fillRule: "evenodd",
    d: "M6.667 2.667a2.333 2.333 0 1 0 0 4.666 2.333 2.333 0 0 0 0-4.666ZM3 5a3.667 3.667 0 1 1 7.333 0A3.667 3.667 0 0 1 3 5Zm1.884 4.667H8A.667.667 0 1 1 8 11H5c-.979 0-1.32.007-1.58.086a2 2 0 0 0-1.334 1.333C2.007 12.68 2 13.021 2 14a.667.667 0 1 1-1.333 0v-.116c0-.818-.001-1.377.143-1.852A3.333 3.333 0 0 1 3.032 9.81c.475-.144 1.034-.144 1.852-.143Zm4.644-.472c.26-.26.683-.26.943 0l1.196 1.195 1.195-1.195a.667.667 0 1 1 .943.943l-1.196 1.195 1.196 1.196a.667.667 0 1 1-.943.942l-1.195-1.195-1.196 1.195a.667.667 0 0 1-.943-.942l1.196-1.196-1.196-1.195a.667.667 0 0 1 0-.943Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveUserIcon2);
export default __webpack_public_path__ + "static/media/remove-user-icon-2.3b3bd96e1d72cca5234a6b7f4d560da5.svg";
export { ForwardRef as ReactComponent };